import React from "react";

function SelfDeclaration(props) {
  return (
    <div className="w-full">
      <div className="bg-white shadow-md rounded-2xl border border-gray-200 p-6 space-y-5">
        {/* Declaration Question as Paragraph */}
        <p className="text-gray-700 leading-relaxed text-justify">
          Has the Applicant, or any of its directors/principal officers, ever
          been, or is currently, listed on any monitoring list maintained by the
          Monetary Authority of Singapore (MAS) or any other relevant regulatory
          authority in relation to anti-money laundering, counter-terrorism
          financing, or related compliance matters?
        </p>

        {/* Answer Section */}
        <div className="space-y-4">
          {/* Status */}
          <div className="flex flex-col sm:flex-row sm:items-start sm:space-x-4">
            <span className="text-gray-600 font-medium min-w-[160px]">
              Declaration:
            </span>
            {props.selfDeclarationss?.isSelfDeclaration !== undefined &&
            props.selfDeclarationss?.isSelfDeclaration !== null ? (
              <span className="text-gray-800 text-sm">
                {props.selfDeclarationss.isSelfDeclaration ? "Yes" : "No"}
              </span>
            ) : (
              <span className="text-gray-500">N/A</span>
            )}
          </div>

          {/* Comment */}
          <div className="flex flex-col sm:flex-row sm:items-start sm:space-x-4">
            <span className="text-gray-600 font-medium min-w-[160px]">
              Declaration Comment:
            </span>
            {props.selfDeclarationss?.selfDeclarationComment ? (
              <p className="bg-gray-50 border border-gray-200 rounded-lg px-4 py-3 text-gray-800 text-sm leading-relaxed 
              w-full sm:w-auto max-w-full break-words overflow-y-auto max-h-40">
                {props.selfDeclarationss.selfDeclarationComment}
              </p>
            ) : (
              <span className="text-gray-500">N/A</span>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelfDeclaration;
